import { Search, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Label } from '../../../components/ui/Label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../../../components/ui/Select';

// ----------------------------------------------------------------------

type Props = {
  label: string;
  filterName: string;
  filterType: string;
  isFiltered: boolean;
  optionsType: string[];
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterType: (value: string) => void;
  onResetFilter: VoidFunction;
};

export default function TaskTableToolbar({
  label,
  filterName,
  filterType,
  isFiltered,
  optionsType,
  onFilterName,
  onFilterType,
  onResetFilter
}: Props) {
  return (
    <div className="flex flex-col sm:flex-row items-center gap-4 px-4 py-4">
      <div className="w-full sm:max-w-[240px]">
        <Label className="sr-only">{label}</Label>
        <Select value={filterType} onValueChange={onFilterType}>
          <SelectTrigger>
            <SelectValue placeholder={label} />
          </SelectTrigger>
          <SelectContent>
            {optionsType.map((option, i) => (
              <SelectItem key={`menu_item_${i}`} value={option} className="capitalize">
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="relative w-full">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          className="pl-9"
        />
      </div>

      {isFiltered && (
        <Button variant="destructive" className="shrink-0" onClick={onResetFilter}>
          <Trash2 className="mr-2 h-4 w-4" />
          Clear
        </Button>
      )}
    </div>
  );
}
